export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8891.634451e2.jpg";